export default __webpack_public_path__ + "static/media/millions-plain.7c8ce342.svg";